import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent, setModalContentProps, } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { deleteFaqItem } from '../../../api/admin/faq';
import { removeItem } from '../../../store/adminSlices/faq';
const ConfirmDeleteFaqItem = ({ itemUid, categoryUid }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [deleteStatus, setDeleteStatus] = useState('idle');
    const closeModal = () => {
        dispatch(setIsModalOpen(false));
        dispatch(setModalContent(null));
        dispatch(setModalContentProps(null));
    };
    const handleConfirm = async () => {
        setDeleteStatus('pending');
        try {
            await deleteFaqItem(itemUid);
            dispatch(removeItem({ categoryUid, itemUid }));
            setDeleteStatus('success');
            closeModal();
        }
        catch {
            // No 409 branch — items have no children that could block delete.
            // Any failure flows to the generic somethingWentWrong modal. Clear the
            // previous modal's content props (WR-02 defense-in-depth) so the
            // SomethingWentWrong modal cannot silently inherit { itemUid,
            // categoryUid } from this delete flow if a future refactor starts
            // reading modalContentProps for it.
            dispatch(setModalContentProps(null));
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    return (_jsxs("div", { className: 'modal-content confirm-action', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.faq.confirm_delete_item'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsxs(ButtonsGroup, { justify: 'center', children: [_jsx(Button, { label: t('button.cancel'), onClick: closeModal, disabled: deleteStatus === 'pending' || deleteStatus === 'success' }), _jsx(Button, { variant: 'outlined', label: t('button.delete_item'), onClick: handleConfirm, disabled: deleteStatus === 'pending' || deleteStatus === 'success' })] }) })] }));
};
export default ConfirmDeleteFaqItem;
